import { useSyncExternalStore } from 'react';
import { apiCallsSnapshot, subscribeApiCalls, type ApiCallRecord } from 'src/components/star-grid/services/apiCallLog';

/** The page's StarGrid API calls, re-rendering as new ones land. */
export const useApiCalls = (): readonly ApiCallRecord[] => useSyncExternalStore(subscribeApiCalls, apiCallsSnapshot);
